"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.closePlaceContentShorthand = exports.openPlaceContentShorthand = void 0;
var css_data_types_1 = require("../../css-data-types");
var shorthand_parser_utils_1 = require("../shorthand-parser-utils");
var getPlaceContentShorthandParts = function () {
    return [
        {
            prop: 'align-content',
            dataType: css_data_types_1.alignContentDataType,
            beforeOpenerCheck: (0, shorthand_parser_utils_1.intersectionBeforeOpenerCheck)('place-content', [
                css_data_types_1.alignContentDataType,
                css_data_types_1.justifyContentDataType,
            ]),
            partOpener: (0, shorthand_parser_utils_1.splitSimpleShorthandOpener)(['align-content', 'justify-content']),
        },
        {
            prop: 'justify-content',
            dataType: css_data_types_1.justifyContentDataType,
            beforeOpenerCheck: (0, shorthand_parser_utils_1.intersectionBeforeOpenerCheck)('place-content', [
                css_data_types_1.alignContentDataType,
                css_data_types_1.justifyContentDataType,
            ]),
        },
    ];
};
// place-content
var openPlaceContentShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandOpener)({
        prop: 'place-content',
        parts: getPlaceContentShorthandParts(),
        shorthandOpener: function (astNodes, api, parts) { return (0, shorthand_parser_utils_1.unorderedListShorthandOpener)(parts)(astNodes, api); },
    });
};
exports.openPlaceContentShorthand = openPlaceContentShorthand;
var closePlaceContentShorthand = function () {
    return (0, shorthand_parser_utils_1.createShorthandCloser)((0, shorthand_parser_utils_1.createShorthandCloserTemplateFromParts)(getPlaceContentShorthandParts()));
};
exports.closePlaceContentShorthand = closePlaceContentShorthand;
//# sourceMappingURL=place-content-shorthand.js.map